export default "__VITE_ASSET__BVOk3K7P__"